import { takeEvery, call, put, CallEffect, PutEffect } from 'redux-saga/effects';
import {
    GetInviteInfo,
    getInviteInfoSuccess,
    GetInviteInfoSuccess,
    InviteActionType,
} from '../../actions/inviteActions';
import { RequestActionType, requestError, requestSuccess } from '../../actions/requestActions';
import getInviteInfo from '../../api/invites';
import ssoDomainLookup from '../../api/sso';
import { Invite, SSOResponse } from '../../models/commonModels';
import RequestActions from '../../models/RequestTypes';
import { RequestType } from '../../reducers/requestReducer';
import history from '../../store/history';
import { toErrorType } from '../isErrorType';

type GetInviteInfoSaga = Generator<
    CallEffect<Invite> | CallEffect<SSOResponse> | PutEffect<GetInviteInfoSuccess> | RequestActions,
    void,
    Invite & SSOResponse
>;
export function* getInviteInfoSaga({ inviteId }: GetInviteInfo): GetInviteInfoSaga {
    try {
        const response = yield call(getInviteInfo, inviteId);
        const { emailAlreadyRegistered, email } = response;
        const emailDomain = email.split('@')[1];
        const lookupResponse = yield call(ssoDomainLookup, { emailDomain });
        if (
            emailDomain !== 'airthings.com' &&
            lookupResponse.clientId !== undefined &&
            lookupResponse.federatedClientId !== undefined &&
            lookupResponse.ssoUri !== undefined &&
            lookupResponse.scope !== undefined
        ) {
            history.push('/sso-login');
        } else if (emailAlreadyRegistered) {
            history.push('/login');
        }

        yield put(getInviteInfoSuccess(response));
        yield put(requestSuccess(RequestType.GetInviteInfo, RequestActionType.Success));
    } catch (error) {
        const errorAsErrorType = toErrorType(error);
        yield put(requestError(errorAsErrorType, RequestType.GetInviteInfo, RequestActionType.Error));
    }
}

export default function* (): Generator {
    yield takeEvery(InviteActionType.GetInviteInfoInit, getInviteInfoSaga);
}
